import Typography from '@mui/material/Typography';
import React from 'react';
import { AutoSizeTextArea } from 'shared/components/ui/auto-size-text-area';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './survey.style';

export type SurveyOpenStepProps = {
  title: string;
  placeholder: string;
  value: string;
  onChangeText: (value: string) => void;
  onContinue: () => void;
  continueLabel: string;
  canContinue: boolean;
  backLabel: string;
  onBack: () => void;
  loading?: boolean;
};

export const SurveyOpenStep: React.FC<SurveyOpenStepProps> = ({
  title,
  placeholder,
  value,
  onChangeText,
  onContinue,
  continueLabel,
  canContinue,
  backLabel,
  onBack,
  loading,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChangeText(event.target.value);
  };

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {title}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Styled.TextField>
          <AutoSizeTextArea
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            focusOnMount
          />
        </Styled.TextField>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.TextPrimary}
          onClick={onBack}
        >
          {backLabel}
        </Button>
        <Button
          size={Sizes.Medium}
          color={Colors.Primary}
          onClick={onContinue}
          disabled={loading || !canContinue}
        >
          {continueLabel}
          {loading ? <Styled.ButtonLoader color="inherit" size={12} /> : null}
        </Button>
      </Styled.Interactions>
    </>
  );
};
